import { Flex, Select, Text } from '@chakra-ui/react'

import { formatTime } from '../../utils/format-time'
import { captalizingSentence } from '../helpers/Helpers'

import type React from 'react'
import type { FieldError, FieldValues, UseFormRegister } from 'react-hook-form'
import type { IArea, ICities } from '../../App'

type TProps = {
  title: string
  name: string
  vehicles?: string[]
  text?: string[]
  areaList?: IArea[]
  options?: ICities[]
  register: UseFormRegister<FieldValues>
  // biome-ignore lint/suspicious/noExplicitAny: idk
  error?: FieldError | any
  disabled?: boolean
  value?: string
  onChangeValue?: (value: string) => void
}

type IVehicleList = {
  car: string
  motorcycle: string
  bus: string
  truck: string
}

const vehicleList: IVehicleList = {
  motorcycle: 'Moto',
  car: 'Carro',
  bus: 'Ônibus',
  truck: 'Caminhão',
}

const SelectInput = ({
  title,
  options,
  name,
  register,
  text,
  areaList,
  error,
  vehicles,
  disabled,
  value,
  onChangeValue,
}: TProps) => {
  const handleChangeValue = (event: React.ChangeEvent<HTMLSelectElement>) => {
    onChangeValue?.(event.target.value)
  }

  return (
    <Flex direction="column" gap="10px" w="100%" fontSize="10px" fontWeight="500">
      <Text fontSize={'xs'} fontWeight={'bold'} color="#000000">
        {title}
      </Text>
      {options && (
        <Select
          errorBorderColor="#EB214E"
          isInvalid={Boolean(error)}
          borderRadius="15px"
          borderWidth="2px"
          borderColor="#DDE4F1"
          bg="white"
          h="55px"
          placeholder="Selecione"
          {...register(name)}
        >
          {options?.map((option, index) => {
            return (
              <option value={option.city} id={option.id.toString()} key={index}>
                {captalizingSentence(option.city)}
              </option>
            )
          })}
        </Select>
      )}
      {areaList && (
        <Select
          errorBorderColor="#EB214E"
          isInvalid={Boolean(error)}
          borderRadius="15px"
          borderWidth="2px"
          borderColor="#DDE4F1"
          bg="white"
          h="55px"
          placeholder="Selecione"
          {...register(name)}
          disabled={disabled}
        >
          {areaList?.map((area, index) => {
            return (
              <option value={area.name} key={index}>
                {captalizingSentence(area?.name)}
              </option>
            )
          })}
        </Select>
      )}
      {text && (
        <Select
          errorBorderColor="#EB214E"
          isInvalid={Boolean(error)}
          borderRadius="15px"
          borderWidth="2px"
          borderColor="#DDE4F1"
          bg="white"
          h="55px"
          placeholder="Selecione"
          {...register(name)}
          disabled={disabled}
          value={value}
          onChange={handleChangeValue}
        >
          {[...text]
            .sort((a, b) => Number(a) - Number(b))
            .map((minute) => {
              return (
                <option value={minute} key={minute}>
                  {formatTime(Number(minute))}
                </option>
              )
            })}
        </Select>
      )}
      {vehicles && (
        <Select
          errorBorderColor="#EB214E"
          isInvalid={Boolean(error)}
          borderRadius="15px"
          borderWidth="2px"
          borderColor="#DDE4F1"
          bg="white"
          h="55px"
          placeholder="Selecione"
          {...register(name)}
          disabled={disabled}
          value={value}
          onChange={handleChangeValue}
        >
          {vehicles?.map((vehicle, index) => {
            return (
              <option value={vehicle} key={index}>
                {vehicleList[vehicle as keyof IVehicleList]}
              </option>
            )
          })}
        </Select>
      )}

      <Flex color="#EB214E">{!!error && error.message}</Flex>
    </Flex>
  )
}

export default SelectInput
